module.exports = __webpack_public_path__ + "img/burger.aa59551b.svg";